import { render, staticRenderFns } from "./PlatformFeeEditForm.vue?vue&type=template&id=1fcd97c2&scoped=true&"
import script from "./PlatformFeeEditForm.vue?vue&type=script&lang=js&"
export * from "./PlatformFeeEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd97c2",
  null
  
)

export default component.exports